import { AILessonPlanResponse, AIMeeting, AIActivity } from '../service/aiLessonPlanService'
import { formatActivityItemsForBackend, ActivityLv4ItemAttribute } from './activityItemsFormatter'

/**
 * Extrai o título do meeting da resposta da IA
 */
export function extractMeetingTitle(meeting: AIMeeting): string {
  return meeting.title || `Encontro ${meeting.meeting_number}`
}

/**
 * Extrai a data do meeting da resposta da IA
 */
export function extractMeetingDate(meeting: AIMeeting): string {
  return meeting.date
}

/**
 * Define o horário padrão do meeting (8:00)
 */
export function getDefaultMeetingTime(): string {
  return '08:00'
}

/**
 * Define a duração padrão do meeting (60 minutos)
 */
export function getDefaultMeetingDuration(): number {
  return 60
}

/**
 * Extrai o título da atividade da resposta da IA
 */
export function extractActivityTitle(activity: AIActivity): string {
  return activity.title || 'Atividade sem título'
}

/**
 * Extrai o planejamento da atividade da resposta da IA
 */
export function extractActivityPlanning(activity: AIActivity): string {
  return activity.planning || '<p>Planejamento não disponível</p>'
}

/**
 * Extrai e formata os itens de nível 4 da atividade (project_items)
 * Retorna no formato esperado pelo backend: { lv4_item_id: "uuid" }
 */
export function extractActivityItems(activity: AIActivity): ActivityLv4ItemAttribute[] {
  const aiItems = activity.activity_lv4_items

  if (!aiItems || !Array.isArray(aiItems) || aiItems.length === 0) {
    return []
  }

  return formatActivityItemsForBackend(aiItems)
}

/**
 * Valida se a resposta da IA é válida
 */
export function validateAIResponse(response: AILessonPlanResponse | null): boolean {
  if (!response) return false
  if (!response.success) return false
  if (!response.meetings || response.meetings.length === 0) return false
  return true
}

/**
 * Conta o total de atividades em todos os meetings
 */
export function countTotalActivities(meetings: AIMeeting[]): number {
  return meetings.reduce((total, meeting) => {
    return total + (meeting.activities?.length || 0)
  }, 0)
}
